import React from "react";
import { Image } from "react-bootstrap";
import logoIcon from "../../assets/images/logoIcon.svg";
import logo from "../../assets/images/black-logo.svg";
import useMobile from "../../hooks/useMobile";

type LogoProps = {
  isAuth: boolean;
  closeRightMenu: any;
  setIsSidebarOpen: any;
  isSidebarOpen: any;
};
function LogoImage({ isAuth, closeRightMenu, setIsSidebarOpen, isSidebarOpen }: LogoProps) {
  const isMobile = useMobile(767);
  const imgLogo = `${isMobile ? "d-none" : "d-inline-block"}`;
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    closeRightMenu();
  };
  return (
    <div className="d-flex aign-items-center position-relative">
      <a href="/" className={`d-flex align-items-center logo ${isSidebarOpen && "active"}`}>
        <div className="logoIcon d-flex align-items-center justify-content-center">
          <Image height={41} width={42} src={`${logoIcon}`} alt="logo" />
        </div>
        <div className="logoText">
          <Image src={`${logo}`} alt="logo" className={`${imgLogo}`} height={29} width={108} />
        </div>
      </a>
      {isAuth && (
        <button
          aria-hidden
          type="button"
          className="toggleMainMenu shadow position-absolute top-50 start-100 translate-middle d-md-block d-none"
          style={{ zIndex: "1" }}
          onClick={toggleSidebar}
        >
          <i className="fa-regular fa-angle-right" />
        </button>
      )}
    </div>
  );
}
export default LogoImage;
